import styled, { css } from "styled-components";

export const wrapper = styled.div`
  ${({ theme }) => css`
    min-width: 25%;
    .text {
      background-color: #ccc;
      width: 100%;
      height: 2rem;
    }

    .skeleton {
      background-color: #ccc;
      margin: 10px 0;
      border-radius: 4px;
    }

    .borderedInput {
      background-color: #ccc;
      width: 70%;
      height: 4rem;
      margin-bottom: 15px;
    }
    .input {
      background-color: #ccc;
      width: 70%;
      height: 2.5rem;
      margin-bottom: 15px;
    }

    .label {
      background-color: #ccc;
      width: 15%;
      height: 2rem;
    }
    .radioParagraph {
      background-color: #ccc;
      width: 50%;
      height: 2rem;
    }

    .radioInput {
      background-color: #ccc;
      width: 2rem;
      height: 2rem;
      border-radius: 50%;
    }

    .radioInputLabel {
      background-color: #ccc;
      width: 70%;
      margin-left: 5%;
      height: 2rem;
    }

    .icon {
      background-color: #ccc;
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
    }
  `}
`;
